// Click-to-call helpers: only French landlines, mobiles and 09 numbers.
export const DEFAULT_WHATSAPP_MESSAGE = "Bonjour, ici Reco Pneus suite à votre appel. 🛞";
export const DEFAULT_WHATSAPP_MESSAGES = {
  reco_pneus: DEFAULT_WHATSAPP_MESSAGE,
  ecrin_du_sud: "Bonjour, ici L'Écrin du Sud suite à votre appel. 🌿",
};

export const callableDigits = (raw) => {
  if (!raw) return "";
  let digits = String(raw).replace(/\D/g, "");
  if (digits.startsWith("33") && digits.length === 11) digits = "0" + digits.slice(2);
  return digits;
};

export const isCallableNumber = (raw) => /^0[1-79]\d{8}$/.test(callableDigits(raw));

// --- Full international number helpers (WhatsApp / copy) ---

// E.164 digits without "+", French-aware: "06 12 34 56 78" and
// "+33612345678" both give "33612345678". "" when not a plausible number.
export const e164Digits = (raw) => {
  if (!raw) return "";
  let s = String(raw).replace(/[^\d+]/g, "");
  if (s.startsWith("+")) s = s.slice(1);
  else if (s.startsWith("00")) s = s.slice(2);
  else if (s.startsWith("0") && s.length === 10) s = "33" + s.slice(1);
  if (!/^\d+$/.test(s)) return "";
  return s;
};

// Full international number (10–15 digits): hides short numbers and
// internal extensions that WhatsApp/copy cannot address.
export const isFullPhoneNumber = (raw) => {
  const d = e164Digits(raw);
  return d.length >= 10 && d.length <= 15;
};

// "+33612345678" form for the clipboard; "" when not a full number.
export const e164Plus = (raw) => (isFullPhoneNumber(raw) ? `+${e164Digits(raw)}` : "");

// Clipboard API with execCommand fallback (iPhone Safari / home-screen PWA).
export const copyText = async (text) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the legacy path
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length); // iOS needs an explicit selection
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
};
